import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import filterList from 'website/containers/lists/filterlist';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userAddToCollection from 'website/containers/user-action/userAddToCollection';
import userRating from 'website/containers/user-action/userRating';
import userReviewLink from 'website/containers/user-action/userReviewLink';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import userFriendsRating from 'website/containers/user/userFriendsRating';
import initCarouselVideo from 'website/module/advertisement/carousel-video';
import carousel from 'website/module/ui/carousel';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import selectChange from 'website/module/ui/select-change';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  carousel();
  initCarouselVideo();

  facebookWidgets();

  thirdNav();

  roller();

  dropdownLinks();

  selectChange();

  filterList();

  // Social user Action
  userOpinion();
  userReviewLink();
  userAddToCollection();
  userFriendsRating();
  userRating();
  userWantToSee();

  socialActionsBootstrap();
});
